import Layout from "../../layout";
import LayoutDashboard from "../referralslayout"
import CandidateHeaderFilter from "./candidateHeaderFilter";
const VendorsReferrals = () => {
  return (
    <Layout>
      <LayoutDashboard>
        <div className="rounded-xl md:border md:border-neutral-100 shadow-md dark:border-neutral-800 md:p-3">
          <CandidateHeaderFilter heading={'Candidates'}/>
        </div>
      </LayoutDashboard>
    </Layout>
  );
};
export default VendorsReferrals;